export const IGNORE = () => {
}
export const THEN_DO_NOTHING = () => {
}

export const LOG_DEBUG = (...args: unknown[]) => console.debug(args)
export const LOG_INFO = (...args: unknown[]) => console.info(args)
export const LOG_ERROR = (...args: unknown[]) => console.error(args)
